import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';

import { environment } from 'src/environments/environment';
import { InfoService } from './info.service';
import { catchError, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PageviewsettingsService {
  private apiUrl = environment.API_URL; 
  private cache: { [key: string]: any } = {}; 
  private settingsCache = new Map<string, BehaviorSubject<any>>();

  private logoSubject = new BehaviorSubject<string>("assets/schooldarklogolg.png");
  private backgroundSubject = new BehaviorSubject<string>("assets/images/default-background.png");
  private bannerSubject = new BehaviorSubject<string>("assets/images/default-banner.png");
  private colourSubject =  new BehaviorSubject<string>("");

  logo$ = this.logoSubject.asObservable();
  background$ = this.backgroundSubject.asObservable();
  banner$ = this.bannerSubject.asObservable();
  color$ = this.backgroundSubject.asObservable()


  constructor(private http: HttpClient,private infoService: InfoService) {}

getPageViewSettingswithcache(affiliateId: number, tenantId: any): Observable<any> {
  const cacheKey = `${affiliateId}-${tenantId}`;
  // 24h in ms, can make configurable
  const ttl = 24 * 60 * 60 * 1000; 

  // 1. this will Check in-memory cache
  if (this.cache[cacheKey]) {
    console.log(`Returning in-memory cached data for: ${cacheKey}`);
    return of(this.cache[cacheKey]);
  }

  // 2. Check localStorage cache
  const stored = localStorage.getItem(cacheKey);
  if (stored) {
    const { data, timestamp } = JSON.parse(stored);

    if (Date.now() - timestamp < ttl) {
      console.log(`localStorage cached data for: ${cacheKey}`);
      this.cache[cacheKey] = data; 
      return of(data);
    } else {
      console.log(` Cache expired for: ${cacheKey}`);
      localStorage.removeItem(cacheKey);
    }
  }

  // 3. Fetch from API if no valid cache
  const url = `${this.apiUrl}/k1mobile/tenant/${tenantId}`;
  console.log(` Fetching from API: ${url}`);

  return this.http.get<any>(url).pipe(
    tap(response => {
      console.log(` Caching response for: ${cacheKey}`, response);

      // Deep copy to avoid mutation
      const safeResponse = JSON.parse(JSON.stringify(response));

      // this will Save in cahe  memory
      this.cache[cacheKey] = safeResponse;

      // this saves in local storage with time satmp
      localStorage.setItem(cacheKey, JSON.stringify({
        data: safeResponse,
        timestamp: Date.now()
      }));
    })
  );
}


  //To be removed later This is used for pageviewsettings by pagename 

  getPageViewSettings(affiliateId: number, tenantId: any, ): Observable<any> {
    const cacheKey = `${affiliateId}-${tenantId}}`;

    // Check if the data is in cache
    if (this.cache[cacheKey]) {
      console.log(`Returning cached data for: ${cacheKey}`, cacheKey);
      return of(this.cache[cacheKey]); // Return cached response as Observable
    }


    const url = `${this.apiUrl}/k1mobile/tenant/${tenantId}`;
    console.log(` from API: ${url}`);


    return this.http.get<any>(url).pipe(
      tap(response => {
        console.log(` Caching response for: ${cacheKey}`, response);

        // Store deep copy of the response in the cache to prevent mutation
        this.cache[cacheKey] = JSON.parse(JSON.stringify(response));
      })
    );
  }







   getbroadbandplans(planid:number): Observable<any> {
  const cacheKey = `${planid}`;

  if (this.cache[cacheKey]) {
    console.log(`Returning cached plans for: ${cacheKey}`);
    return of(this.cache[cacheKey]);
  }

  const url = `${this.apiUrl}/k1mobile/k1mobile/mobile_plan_id/${planid}`;
  console.log(`Fetching plans from API: ${url}`);

  return this.http.get<any>(url).pipe(
    tap(response => {
      this.cache[cacheKey] = JSON.parse(JSON.stringify(response));
    })
  );
}


 
 


  getCollegetenantcode(collegeName: string): Observable<any> {
 
   return this.http.get(`${this.apiUrl}/k1mobile/tenant/code/${collegeName}`);
}
    



   async createvisitoranalytics(eventname: any,email:string) {
    const ip = await this.infoService.getIPAddress();
    const browser = this.infoService.getBrowserInfo();
    // const eventname = 'collegiatemobilelandingpage'

    const userId = crypto.randomUUID();  

    let obj = {
    
  "affiliateId": 1,
  "eventName":eventname ,
  "tenantId": 1,
  "correlationId": "",
  "userAgent": browser,
  "remoteIPAddress":ip,
  "referer": "",
  "campaignId": 0,
  "emailAddress":email,
  "utmId": "string",
  "utmSource": "string",
  "utmMedium": "string",
  "utmCampaign": "string",
  "utmTerm": "string",
  "utmContent": "string",
  "queryString": "string",
  "visitorGuid": crypto.randomUUID(),
  "landingEvent": "2025-08-20T10:09:21.211Z",
  "fanEvent": "2025-08-20T10:09:21.211Z",
  "studentEvent": "2025-08-20T10:09:21.211Z",
  "planEvent": "2025-08-20T10:09:21.211Z",
  "studentBasic": "2025-08-20T10:09:21.211Z",
  "studentPlus": "2025-08-20T10:09:21.211Z",
  "studentUnlimited": "2025-08-20T10:09:21.211Z",
  "fanBasic": "2025-08-20T10:09:21.211Z",
  "fanPlus": "2025-08-20T10:09:21.211Z",
  "fanPremium": "2025-08-20T10:09:21.211Z",
  "fanUnlimited": "2025-08-20T10:09:21.211Z",
  "fanSuperPremium": "2025-08-20T10:09:21.211Z"

      
    };

    return this.http.post(`${this.apiUrl}/k1mobile/visitor_analytics/`, obj).toPromise();
  }

 creategiveawayentry(guid:any,formobj:any) {
  

	let obj = {
		"eventGUID": guid,
		"name": formobj.name,
		"emailAddress": formobj.email,
		"stateCode": formobj.state,
		"phone": formobj.phone,
		"agreeToGiveawayTerms": formobj.agree
	}

    return this.http.post(`${this.apiUrl}/k1mobile/giveaway/entry`, obj);
  }



 
clearCache(keys: string[]) {
  for (const key of keys) {
    if (this.cache[key]) {
      console.log(`Clearing cache for: ${key}`);
      delete this.cache[key];
    }
  }
}




}
